const KITHE_HOSTNAMES = ["kithe.club", "www.kithe.club"];
const ERNEST_HOSTNAMES = ["ernest-app.com", "www.ernest-app.com"];
const KITHE_ORIGIN = "https://kithe.club";

/** True when the app is being served from the kithe.club community domain.
 *  Defaults to false (ernest) when there's no window — build-time prerendering. */
export const isKitheDomain = () =>
  typeof window !== "undefined" && KITHE_HOSTNAMES.includes(window.location.hostname);

/** Origin an auth email (password reset, magic link) should send a community
 *  member back to. Supabase only honours a redirect that matches its allow
 *  list, so this must stay in sync with the Redirect URLs configured on the
 *  project — anything else is silently swapped for the Site URL, which is
 *  ernest's landing page.
 *
 *  On kithe.club we keep the current origin; from ernest-app.com we hand the
 *  member over to kithe.club so the reset page arrives under their own brand;
 *  everywhere else (localhost, preview builds) we stay put so the link works
 *  where it was requested. */
export const kitheAuthOrigin = () => {
  if (typeof window === "undefined") return KITHE_ORIGIN;
  const { hostname, origin } = window.location;
  if (ERNEST_HOSTNAMES.includes(hostname)) return KITHE_ORIGIN;
  return origin;
};
